"use strict";
//import { api_prefix } from "./index";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Order_API_PATH = exports.OrderPath = void 0;
const order = "/order";
exports.OrderPath = {
    order,
};
const api_prefix = "api";
const handlePath = ({ path }) => {
    const apiPath = {
        frontend: `${api_prefix}${order}/${path}`,
        backend: `/${path}`,
    };
    return apiPath;
};
exports.Order_API_PATH = {
    newOrder: handlePath({
        path: `new`,
    }),
    getOrderByNumber: (orderNumber) => handlePath({
        path: orderNumber,
    }),
    getOrdersByClient: handlePath({
        path: `client`,
    }),
    cancelOrder: (orderId) => handlePath({
        path: `cancel/${orderId}`,
    }),
    confirmPayment: (orderId) => handlePath({
        path: `confirm_payment/${orderId}`,
    }),
    getQrCode: (code) => handlePath({
        path: `qr_code/${code}`,
    }),
    getOrderByPaymentNumber: (paymentNumber) => handlePath({
        path: `payment_number/${paymentNumber}`,
    }),
    verifyOrderPayment: (orderNumber) => handlePath({
        path: `payment_verify/${orderNumber}`,
    }),
    filterOrders: handlePath({
        path: `filtered`,
    }),
    orderWithClient: (orderNumber) => handlePath({
        path: `with_client/${orderNumber}`,
    }),
    searchOrderWithClient: handlePath({
        path: `with_client/search`,
    }),
    pickupOrder: (pickupCode) => handlePath({
        path: `pickup/` + pickupCode,
    }),
    getPendingPaymentUrl: (orderNumber) => handlePath({
        path: `pending_url/` + orderNumber,
    }),
};
//# sourceMappingURL=order.js.map